module.exports = __webpack_public_path__ + "img/app-5.cb6ad859.png";